import TelegramIcon from '@mui/icons-material/Telegram';
import EmailIcon from '@mui/icons-material/Email';
import ChatIcon from '@mui/icons-material/Chat';
import { ZapyIcon } from '../../../components/icons/ZapyIcon';
import { ChannelType } from '../../../types/chat.types';

interface ChannelTypeIconProps {
  type?: ChannelType | null;
}

/**
 * Renders the appropriate icon for a given channel type.
 * Reusable across contact identities, conversation lists, etc.
 */
export const ChannelTypeIcon = ({ type }: ChannelTypeIconProps) => {
  switch (type) {
    case ChannelType.ZAPY:
      return <ZapyIcon />;
    case ChannelType.TELEGRAM:
      return <TelegramIcon sx={{ color: '#0088cc' }} />;
    case ChannelType.EMAIL:
      return <EmailIcon color="action" />;
    default:
      return <ChatIcon />;
  }
};
